package com.nonopn.skydome.common.app.pages.main.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material.OutlinedButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog

import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.home.LocalIsPreview
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skydome.common.app.pages.main.view.map.MapOverlay
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.google_logo_dark
import com.nonopn.skywatcher.common.app.res.preview
import com.nonopn.skywatcher.common.app.res.select_hint
import com.nonopn.skywatcher.common.app.res.select_hint_dismiss
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.DefaultCard

import de.drick.compose.hotpreview.HotPreview

import eu.codlab.compose.widgets.TextNormal

import org.jetbrains.compose.resources.painterResource

import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import ovh.plrapps.mapcompose.ui.MapUI

@Composable
fun Map(
    modifier: Modifier,
    model: MainScreenModel
) {
    if (LocalIsPreview.current) {
        Column(
            modifier = modifier,
        ) {
            Image(
                painter = painterResource(Res.drawable.preview),
                contentDescription = ""
            )
        }
        return
    }
    model.configureMapState()
    val state by model.states.collectAsState()
    Box(modifier) {
        if (!state.initialized) {
            return@Box
        }
        FullscreenMapContainer(
            modifier = Modifier.fillMaxSize(),
            // The corners are used by the map overlay
            controlsAlignment = Alignment.BottomCenter,
            closeAlignment = Alignment.BottomCenter,
            controlsPadding = 12.dp,
        ) {
            MapUI(
                modifier = Modifier.fillMaxSize(),
                state = model.mapState
            )
            MapOverlay(
                modifier = Modifier.fillMaxSize(),
                model
            )
            // Select point hint dialog
            if (state.showSelectPointHint) {
                Dialog(
                    onDismissRequest = {
                        model.updateState { copy(showSelectPointHint = false) }
                    }
                ) {
                    DefaultCard(backgroundColor = AppColor.White) {
                        Column(
                            modifier = Modifier.padding(16.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            TextNormal(
                                text = Res.string.select_hint.localized(),
                                color = AppColor.StrikeText,
                                textAlign = TextAlign.Center
                            )
                            Spacer(Modifier.height(16.dp))
                            OutlinedButton(
                                onClick = {
                                    model.updateState { copy(showSelectPointHint = false) }
                                }
                            ) {
                                TextNormal(
                                    text = Res.string.select_hint_dismiss.localized(),
                                    color = AppColor.StrikeText
                                )
                            }
                        }
                    }
                }
            }
            Row(
                modifier = Modifier.align(Alignment.BottomStart).padding(12.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                Image(
                    modifier = Modifier.height(15.dp),
                    painter = painterResource(Res.drawable.google_logo_dark),
                    contentDescription = ""
                )
            }
            Row(
                modifier = Modifier.align(Alignment.BottomEnd).padding(12.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                TextNormal(
                    text = LocalApp.current.appTitle.localized()
                )
            }
        }
    }
}
@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun MapPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme(), isPreview = true) {
        Map(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false
            )
        )
    }
}
